import { client, gql } from 'data-provider';
import { MeiliSearch, SearchParams } from 'meilisearch';
import jwtDecode from 'jwt-decode';

let searchClient: MeiliSearch;

export const initializeSearch = async () => {
  const token = await getSearchToken();
  setSearchToken(token);
  searchClient = new MeiliSearch({
    host: process.env.REACT_APP_MEILISEARCH_HOST!,
    apiKey: token,
  });
};

export const createSearchToken = async () => {
  const mutation = gql`
    mutation {
      createSearchToken
    }
  `;

  const data = await client.request(mutation);
  return data.createSearchToken as string;
};

export const setSearchToken = (token: string) => window.localStorage.setItem('searchToken', token);

export const getSearchToken = async () => {
  const userToken = window.localStorage.getItem('token')!;
  const savedSearchToken = window.localStorage.getItem('searchToken');

  // Create token when there's no token
  if (!savedSearchToken) {
    return await createSearchToken();
  }

  const decodedSearchToken: Record<string, any> = jwtDecode(savedSearchToken);
  const decodedUserToken: Record<string, any> = jwtDecode(userToken);

  // Create token if token is expired
  const tokenExpirationTime = decodedSearchToken.exp;
  const currentTime = new Date().getTime();
  if (tokenExpirationTime <= currentTime) {
    return await createSearchToken();
  }

  const userOrgId = decodedUserToken[`org_id`];
  const userAppId = decodedUserToken[`${process.env.REACT_APP_IDENTIFIER}/instans_id`];
  const tenantId: string = decodedSearchToken.searchRules['*'].filter
    .replace('org_id', '')
    .replace('=', '')
    .trim();
  const [orgId, appId] = tenantId.split('::');

  // Check Org and App ID matched with User Org and App ID
  if (userOrgId !== orgId || userAppId !== appId) {
    return await createSearchToken();
  }

  return savedSearchToken;
};

export class SearchIndex {
  static Sales = this.getIndexName('sales');
  static Purchase = this.getIndexName('purchases');
  static Product = this.getIndexName('products');
  static ProductVariant = this.getIndexName('product_variants');
  static Client = this.getIndexName('clients');
  static Supplier = this.getIndexName('suppliers');
  static Damage = this.getIndexName('damages');
  static Return = this.getIndexName('returns');
  static TransferStock = this.getIndexName('transfer_stocks');
  static Warehouse = this.getIndexName('warehouses');
  static Tag = this.getIndexName('tags');
  static Category = this.getIndexName('categories');
  static Expense = this.getIndexName('expenses');
  static ExpenseCategory = this.getIndexName('expense_categories');
  static Manufacture = this.getIndexName('manufactures');
  static MeasurementUnit = this.getIndexName('measurement_units');

  private static getIndexName(baseName: string): string {
    const env = process.env.REACT_APP_APP_ENV;
    switch (env) {
      case 'production':
        return baseName;
      case 'staging':
        return `${baseName}_qa`;
      default:
        return `${baseName}_dev`;
    }
  }
}

export const getSearchData = async (
  index: string,
  searchString: string,
  options?: SearchParams
) => {
  const response = await searchClient.index(index.toLowerCase()).search(searchString, options);
  return response.hits;
};
